import SizeSelector from './SizeSelector';

export default SizeSelector;
